import {
  type GetClientSetupStatusResponseAPI,
  TimeOffEditingMethod,
} from '@omnipresentgroup/types';

export const GET_CLIENT_SETUP_STATUS_DEFAULT_RESPONSE: GetClientSetupStatusResponseAPI =
  {
    time_off_editing_method: TimeOffEditingMethod.MANUAL,
  };
